<template>
    <!-- ランキングパーツ -->
    <div :class="ptInitData.tateFlag == true?'pt070 tate':'pt070'" v-cloak>
        <!--タイトル-->
        <div class="itemTitle">
            <h3>{{$t('pt070.labels.title')}}</h3>
        </div>
        <!--店舗名または顧客グループ名を表示-->
        <span v-if="showUnitNm" class="uinitNm">
            {{$t('pt070.labels.group')}}{{ pt070Init.unitNm }}
        </span>
        <!--カテゴリ名を表示-->
        <span v-if="showCateNm" class="categoryNm">
            {{ pt070ReqModel.categoryNm }}{{$t('pt070.labels.title')}}
        </span>
        <div class="mwButton" v-if="pt070ReqModel.otherFlg == 0">
            <!--月次ボタン-->
            <button :class="pt070ReqModel.totalKbn == '1'?'btnSubmit focus':'btnSubmit'" @click="change('1')">
                {{$t('pt070.labels.mRank')}}
            </button>
            <!--週次ボタン-->
            <button :class="pt070ReqModel.totalKbn == '2'?'btnSubmit focus':'btnSubmit'" @click="change('2')">
                {{$t('pt070.labels.wRank')}}
            </button>
        </div>
        <!--他のグループを見るボタンを押下時表示-->
        <div v-if="pt070ReqModel.otherFlg == 1 && getLengthObj(pt070Init.kokyakuGrList) > 0">
            <!--顧客グループ一覧を表示-->
            <div v-for="(item, index) in pt070Init.kokyakuGrList" :key="index" class="otherButtons">
                <button class="btnSubmit" @click="change2(item.KEY)">
                    {{ item.VALUE }}
                </button>
            </div>
        </div>
        <!-- カテゴリ一覧を表示
        <div v-if="pt070ReqModel.cateOtherFlg == 1 && getLengthObj(pt070Init.categoryList) > 0">
            
            <div v-for="(item, index) in pt070Init.categoryList" :key="index" class="otherButtons">
                <button class="btnSubmit" @click="change3(item.CATEGORY_CD,item.CATEGORY_NM)">
                    {{ item.CATEGORY_NM }}
                </button>
            </div>
        </div>
        -->
        <!--ランキング一覧を表示-->
        <div class="products" v-if="getLengthObj(pt070Init.rankingList) > 0">
            <div class="productSet" v-for="(item, index) in pt070Init.rankingList" :key="index">
                <router-link :to="{ name: SiteConstants.PG030 , params: {pageNo: 3, sItemNo: item.S_ITEM_CD}}" @click.native="reload">
                    <!-- ランキング商品 -->
                    <p class="rank-cnt" v-if="item.RANK <= 10">
                        <img class="rankCntImg" :src="item.RANK_IMG" @error="getErrImage" :alt="'ランキング画像'">
                    </p>
                    <!--商品画像-->
                    <img class="rankingImg" :src="item.IMG_URL1" @error="getErrImage" :alt="item.THUMBNAIL_DETAIL">
                    <!--WEB商品名-->
                    <P class="rankingItemNm">
                        {{ item.WEB_ITEM_NM }}
                    </p>
                    <template v-if="!(pt070Init.siteKbn == '4' && !pt070Init.login) && pt070Init.priceShow != 1">
                        <!--商品金額(税込)-->
                        <template v-if="item.ZEI_SET_KBN == '1'">
                            <P class="productPrice" >
                                <!--税込金額 -->
                                <span class="generalZeiPrice">{{$t('common.labels.price')}}：{{ formatPrice(item.SALE_ZEI_K_TNK) }} {{ $t('common.labels.jpYen') }} {{$t('common.labels.taxincluded')}}</span>
                            </p>
                        </template>
                        <template v-else>
                            <P class="productPrice">
                                <!--税抜金額 -->
                                <span class="generalPrice">{{$t('common.labels.price')}}：{{ formatPrice(item.SALE_TNK) }} {{ $t('common.labels.jpYen') }} {{$t('common.labels.excludingtax')}}</span>
                                <br>
                                <!--税込金額 -->
                                <span class="generalZeiPrice">{{$t('common.labels.zeiPrice')}}：{{ formatPrice(item.SALE_ZEI_K_TNK) }} {{ $t('common.labels.jpYen') }} {{$t('common.labels.taxincluded')}}</span>
                            </p>
                        </template>
                        <!--値引価格 -->
                        <P class="nebikiPrice" v-if="item.NEIBIKI_ZEI_K_TNK > 0 && ((item.ZEI_SET_KBN == '1' && item.NEIBIKI_ZEI_K_TNK != item.SALE_ZEI_K_TNK) || (item.ZEI_SET_KBN != '1' && item.NEIBIKI_ZEI_K_TNK != item.SALE_TNK))">
                            {{$t('common.labels.nebikiPrice')}}：{{ formatPrice(item.NEIBIKI_ZEI_K_TNK) }} {{ $t('common.labels.jpYen') }} 
                            <template v-if="item.ZEI_SET_KBN == '1'">{{$t('common.labels.taxincluded')}}</template>
                            <template v-else>{{$t('common.labels.excludingtax')}}</template>
                        </p>
                    </template>
                </router-link>
            </div>
        </div>
        <!--ランキング一覧が無い場合のメッセージ表示-->
        <div v-else-if="getLengthObj(pt070Init.rankingList) == 0 && pt070ReqModel.otherFlg == 0" class="noneMessage">
            {{ $t('pt070.labels.none') }}
        </div>
        <div class="otherButton" v-if="pt070Init.kokyakuGroupOption == 1 && pt070ReqModel.otherFlg == 0 && pt070Init.login">
            <!--他のグループを見るボタン-->
            <button class="btnSubmit" @click="other()">
                {{ $t('pt070.labels.other') }}
            </button>
        </div>
        <!-- 他のカテゴリを見る 
        <div class="otherCategrory" v-if="pt070ReqModel.categoryCd == '0'">
            <button class="btnSubmit" @click="cateOther()">
                {{ $t('pt070.labels.cateOther') }}
            </button>
        </div>
        -->
    </div>
</template>
<script>
import $ from 'jquery';
import axios from "assets/js/request";
import common from "assets/js/common";
import SiteConstants from 'assets/const/SiteConstants.json';
import { Carousel, Slide } from 'vue-carousel';

export default {
    name: "PT070RankingParts",
    components:{
        Carousel,
        Slide
    },
    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
            tateFlag: false
        },
    },
    data() {
        return {
            pt070Init:{},
            pt070ReqModel:{
                otherFlg: 0,
                totalKbn: '1'
            },
            SiteConstants: SiteConstants,
            showCateNm: false,
            showUnitNm: false
        }
    },
    /*
    * 初期処理
    */
    mounted() {
        var _this = this;
        _this.$emit("event-loading", true);
        if (_this.ptInitData){
            _this.pt070Init = _this.ptInitData;
            _this.pt070ReqModel.totalKbn = _this.ptInitData.reqModel.totalKbn;
            _this.pt070ReqModel.categoryCd = _this.ptInitData.reqModel.categoryCd;

            if ($(".pt070").width() < 300) {
                _this.ptInitData.tateFlag = true;
            }
            _this.$emit("event-loading", false);
        } else {
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT070 + _this.$UrlConstants.DO_INIT, _this.pt070ReqModel).then(function(response) {
                //set data init
                _this.pt070Init = response.data;
                _this.pt070ReqModel.totalKbn = response.data.reqModel.totalKbn;
                _this.pt070ReqModel.categoryCd = response.data.reqModel.categoryCd;
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                common.errorAPI(error);
                _this.$emit("event-loading", false);
            });
        }
    },
    methods: {
        /*
        * 週間、月間変更
        */
        change: function(kbn) {
            var _this = this;
            _this.$emit("event-loading", true);
            _this.pt070ReqModel.totalKbn = kbn;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT070 + _this.$UrlConstants.DO_SEARCH, _this.pt070ReqModel).then(function(response) {
                //set data init
                _this.pt070Init = response.data;
                _this.showUnitNm = false;
                _this.showCateNm = false;
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                common.errorAPI(error);
                _this.$emit("event-loading", false);
            });
        },
        /*
        * 顧客グループ変更
        */
        change2: function(unitCd) {
            var _this = this;
            _this.$emit("event-loading", true);
            _this.pt070ReqModel.otherFlg = 0;
            _this.pt070ReqModel.unitCd = unitCd;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT070 + _this.$UrlConstants.DO_SEARCH, _this.pt070ReqModel).then(function(response) {
                //set data init
                _this.pt070Init = response.data;
                _this.showUnitNm = true;
                _this.showCateNm = false;
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                common.errorAPI(error);
                _this.$emit("event-loading", false);
            });
        },
        /*
        * カテゴリ変更
        */
        change3: function(categoryCd,categoryNm) {
            var _this = this;
            _this.$emit("event-loading", true);
            _this.pt070ReqModel.otherFlg = 0;
            _this.pt070ReqModel.cateOtherFlg = 0;
            _this.pt070ReqModel.categoryCd = categoryCd;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT070 + _this.$UrlConstants.DO_SEARCH, _this.pt070ReqModel).then(function(response) {
                //set data init
                _this.pt070Init = response.data;
                _this.pt070ReqModel.otherFlg == 1;
                _this.pt070ReqModel.categoryCd = '0';
                _this.pt070ReqModel.categoryNm = categoryNm;
                _this.showCateNm = true;
                _this.showUnitNm = false;
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                common.errorAPI(error);
                _this.$emit("event-loading", false);
            });
        },
        /*
        * 顧客グループリストを取得
        */
        other: function() {
            var _this = this;
            _this.pt070ReqModel.otherFlg = 1;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT070 + _this.$UrlConstants.DO_SEARCH, _this.pt070ReqModel).then(function(response) {
            //set data init
            _this.pt070Init = response.data;
            _this.showCateNm = false;
            _this.showUnitNm = false;
            }).catch(function(error) {
            common.errorAPI(error);
            });
        },
        /*
        * 親カテゴリリストを取得
        */
        cateOther: function() {
            var _this = this;
            _this.pt070ReqModel.cateOtherFlg = 1;
            _this.pt070ReqModel.otherFlg = 1;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT070 + _this.$UrlConstants.DO_SEARCH, _this.pt070ReqModel).then(function(response) {
            //set data init
            _this.pt070Init = response.data;
            _this.showCateNm = false;
            _this.showUnitNm = false;
            }).catch(function(error) {
            common.errorAPI(error);
            });
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        /*
        * format price
        */
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        /*
        * Get length obj
        */
        getLengthObj: function(obj) {
            if(obj != undefined)
            return common.getLengthObj(obj);
        },
        /**
         * Reload page
         */
        reload: function() {
            this.$router.go(0);
        },
    },
    created(){
        var _this = this;
        // Get data from params and query
        var paramData = _this.$route.params;
        var queryData = _this.$route.query;

        if(Object.keys(paramData).length > 0){
            _this.pt070ReqModel = Object.assign({}, _this.pt070ReqModel, paramData);
        }

        if(Object.keys(queryData).length > 0){
            _this.pt070ReqModel = Object.assign({}, _this.pt070ReqModel, queryData);
        }
    },
}
</script>
